import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { PowerBIEmbed } from 'powerbi-client-react';

import {
  getPbiUrlConfigsForGlobalCycles,
  getReportIdForGen2,
  getDatasetId,
  getEmbedConfig
} from '../PortfolioDetailView/PBIReports';
import { fetchPBIEmbedToken } from '../PortfolioDetailView/services';

import '../PortfolioDetailView/iframe.css';

const GlobalCycleTriggerTable = () => {
  const [pbiEmbedToken, setPbiEmbedToken] = useState('');
  const [selectedUrl, setSelectedUrl] = useState('');
  const reportId = getReportIdForGen2();

  useEffect(() => {
    getPBIEmbedToken(getReportIdForGen2(), getDatasetId());
    const tabs = getPbiUrlConfigsForGlobalCycles();
    // pick the tab/report url for Global Cycle Trigger
    const globalTab = tabs.find((tab) => tab.id === 'globalCycleTrigger');
    if (globalTab) {
      setSelectedUrl(globalTab.pbi_url);
    }
  }, []);

  const getPBIEmbedToken = async (reportId, datasetId) => {
    const embedToken = await fetchPBIEmbedToken(reportId, datasetId);
    setPbiEmbedToken(embedToken);
  };

  const getFilteredURL = (url) => {
     return `${url}&disableSensitivityBanner=true&experience=power-bi&navContentPaneEnabled=false`;
  };

  return (
    <Stack gap="16px" sx={{ padding: '24px', width: '100%' }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {selectedUrl && (
          <div className="iframe-paper-container">
            <div className="iframe-container">
              <div className="iframe-content">
                <PowerBIEmbed
                  key={reportId}
                  embedConfig={getEmbedConfig(getFilteredURL(selectedUrl), pbiEmbedToken)}
                  cssClassName={'report-style-class'}
                />
              </div>
            </div>
          </div>
        )}
      </Box>
    </Stack>
  );
}

export default GlobalCycleTriggerTable;
